import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";
import { TbAlertCircle } from "react-icons/tb";
import { PiCellSignalFullFill, PiCellSignalLowFill, PiCellSignalMediumFill, PiCellSignalNoneFill } from "react-icons/pi";

const iconMapping = {
  'signal-none': PiCellSignalNoneFill,
  'signal-low': PiCellSignalLowFill,
  'signal-medium': PiCellSignalMediumFill,
  'signal-full': PiCellSignalFullFill,
  'alert-circle': TbAlertCircle,
};

export function TaskPrioritySelect({ priorities, value, onChange, className }) {
  const [open, setOpen] = useState(false);

  const getIcon = (iconId) => {
    const IconComponent = iconMapping[iconId];
    if (!IconComponent) {
      console.warn(`Icon not found: ${iconId}`);
      return PiCellSignalMediumFill; // fallback icon
    }
    return IconComponent;
  };

  return (
    <div className={className}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <div className="flex items-center gap-3">
            <Button 
              variant="ghost" 
              size="sm" 
              type="button"
              className="h-7 px-1.5 -ml-1.5 flex items-center gap-2"
            >
              {React.createElement(getIcon(priorities[value].icon), { 
                className: `w-5 h-5 ${priorities[value].color}` 
              })}
              {priorities[value].name}
            </Button>
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-[200px] p-0" side="top" align="start">
          <Command>
            <CommandInput placeholder="Change priority..." />
            <CommandList>
              <CommandEmpty>No priority found.</CommandEmpty>
              <CommandGroup>
                {Object.entries(priorities).map(([key, priority]) => (
                  <CommandItem
                    key={key}
                    value={key}
                    onSelect={() => {
                      onChange(key);
                      setOpen(false);
                    }}
                  >
                    <div className="flex items-center gap-2">
                      <Button variant="ghost" size="sm" className="h-7 px-1.5 flex items-center gap-2">
                        {React.createElement(getIcon(priority.icon), { 
                          className: `w-4 h-4 ${priority.color}` 
                        })}
                        {priority.name}
                      </Button>
                    </div>
                    {value === key && (
                      <Check className="ml-auto h-4 w-4" />
                    )}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
} 